import { useEffect } from 'react'
import { useAdminPromoStore } from '@/modules/admin/state/promoStore'
import { useAdminArticlesStore } from '@/modules/admin/state/articlesStore'
import { promoApi } from '@/modules/promo-api'
import { articlesApi } from '@/modules/articles-api'

export function useAutoFetchPromo() {
  const loaded = useAdminPromoStore((s) => s.loaded)
  useEffect(() => {
    if (loaded) return
    Promise.all([
      promoApi.listCampaigns().catch(() => []),
      promoApi.listFlashDeals().catch(() => []),
    ]).then(([cs, ds]) => {
      useAdminPromoStore.setState({ campaigns: Array.isArray(cs) ? cs : ((cs as any)?.items ?? []), deals: Array.isArray(ds) ? ds : ((ds as any)?.items ?? []), loaded: true })
    })
  }, [loaded])
}

/**
 * Luôn fetch public /articles ở AppShell (cho NewsPage).
 * Admin page sẽ fetch /admin/articles riêng khi mount (ArticlesListPage).
 */
export function useAutoFetchArticles() {
  const loaded = useAdminArticlesStore((s) => s.loaded)
  useEffect(() => {
    if (loaded) return
    articlesApi.listPublic({ page: 1, pageSize: 200 })
      .then((p) => {
        const list = Array.isArray(p) ? p : (p?.items ?? []); const items = list.map((a: any) => ({ ...a, status: (a.status === 'PUBLISHED' || a.status === 'published') ? 'published' : 'draft' }))
        useAdminArticlesStore.setState({ articles: items, loaded: true })
      })
      .catch((err) => {
        console.warn('[articles] public fetch failed:', err?.message)
        useAdminArticlesStore.setState({ articles: [], loaded: true })
      })
  }, [loaded])
}
